// eslint-disable-next-line no-restricted-imports
import { HStack, Text, Icon as ChakraIcon } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';
import { LogIn } from 'lucide-react';

type IProps = {
  onLoginClick: Dispatch<SetStateAction<boolean>>;
};

const DesktopLogin: React.FC<IProps> = (props: IProps) => (
  <HStack
    spacing={2}
    cursor="pointer"
    _hover={{ color: '#B3B6F7' }}
    onClick={(e) => props.onLoginClick(true)}
    display={{ base: 'none', md: 'flex' }}>
    <ChakraIcon as={LogIn} w={5} h={5} color="gray.800" />
    <Text
      color="gray.800"
      fontWeight="semibold"
      fontSize="16px"
      fontFamily="marketingPage">
      Log In
    </Text>
  </HStack>
);

export default DesktopLogin;
